module.exports = __webpack_public_path__ + "img/ppc.dc3c349b.webp";